export default function Identification() {
  return (
    <section className="access-section">
      <span className="gold-rule-v" aria-hidden />
      <div className="access-container max-w-3xl">
        <span className="mono-label mono-label-gold">Who this is for</span>
        <h2 className="h-section mt-6">
          You've watched the videos. You've taken the notes. You still <span>don't have an offer.</span>
        </h2>
        <div className="mt-12 space-y-7 body-lg">
          <p>You know remote sales is real. You've seen the numbers. You've seen 20-year-olds clearing 10k a month on a Mac in Bali.</p>
          <p>You've watched Iman. You've watched Cole. You've watched the YouTube guys give you "everything you need for free."</p>
          <p className="text-bone font-display italic text-2xl md:text-3xl leading-snug" style={{ fontVariationSettings: '"opsz" 144, "SOFT" 80', fontWeight: 350 }}>And you still haven't closed a deal.</p>
          <p>Not because you're stupid. Because watching content is not the same thing as being inside a room where the standard is moving. You don't have a frame. You don't have reps. You don't have a network. And nobody is going to place you.</p>
          <p className="text-bone">That's the actual gap.</p>
        </div>
      </div>
    </section>
  );
}
